var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('foreignObject',{staticClass:"impact-icon",attrs:{"width":18,"height":24}},[_c('icon',{style:({ color: _vm.color }),attrs:{"icon":"cubelogo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }